import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchAreasList } from '@/features/areas/api'
import { fetchSite } from '@/features/sites/api'
import { siteParamsSchema } from '@/routes/_protected/$tenantKey/settings/sites/-models'

// 地点マスタ
export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/sites/$siteId'
)({
  parseParams: (params) => parse(siteParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, siteId },
    context: { auth }
  }) => {
    const [site, allAreasResponse, disabledAreasResponse] = await Promise.all([
      fetchSite({ tenantKey, siteId }, abortController.signal),
      // 無効なエリアのエリア名を詳細画面に設定するために全エリア取得(有効・無効両方)
      fetchAreasList(
        { tenantKey, query: { page: -1 } },
        abortController.signal
      ),
      // 無効なエリアのみ取得
      fetchAreasList(
        { tenantKey, query: { page: -1, enable: false } },
        abortController.signal
      )
    ])

    // AreaListExEntity を AreaSelectListExEntity 形式に変換
    const areaSelectList = allAreasResponse.data.map((area) => ({
      id: area.id,
      code: area.code,
      name: area.name,
      isArea: true
    }))

    const disabledAreaIds = disabledAreasResponse.data.map((area) => area.id)

    return {
      authUser: auth.user,
      site,
      areaSelectList,
      disabledAreaIds
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.site.name
    }
  ]
})
